<template>

  <div class="einvoice-filter">
     <b-row class="align-items-end"
      > <b-col
        md="3"
        class="mb-3"
        > <label class="einvoice-filter__label">Loại hóa đơn</label>
        <b-button-group
          size="sm"
          class="w-100"
          > <b-button
            v-for="option in billTypeOptions"
            :key="option.value"
            :variant="isBillTypeActive(option.value) ? 'primary' : 'outline-primary'"
            @click="onToggleBillType(option.value)"
            > {{ option.text }} </b-button
          > </b-button-group
        >
        <small
          v-if="billTypeBlockedReason"
          class="d-block text-danger mt-2"
          > {{ billTypeBlockedReason }} </small
        > </b-col
      > <b-col
        md="2"
        class="mb-3"
        > <label class="einvoice-filter__label">Trạng thái</label> <b-form-select
          v-model="draftFilter.status"
          class="select-style"
          size="sm"
          > <b-form-select-option :value="null">Tất cả trạng thái</b-form-select-option>
          <b-form-select-option
            v-for="opt in statusOptions"
            :key="opt.value"
            :value="opt.value"
            > {{ opt.text }} </b-form-select-option
          > </b-form-select
        > </b-col
      > <b-col
        v-if="showStoreFilter"
        md="3"
        class="mb-3"
        > <label class="einvoice-filter__label">Chi nhánh</label>
        <BDropdownCustom
          :value="selectedStores"
          :options="stores"
          :placeholder="'chi nhánh'"
          :searchable="true"
          :matchKey="['name', 'shortName']"
          :limit="10"
          :compareById="true"
          :multiple="true"
          @valueChange="onStoreSelectionChange"
        /> </b-col
      > <b-col
        md="2"
        class="mb-3"
        > <label class="einvoice-filter__label">MST người mua</label> <b-form-input
          v-model="draftFilter.buyerTaxCode"
          size="sm"
          maxlength="24"
          placeholder="Nhập MST..."
          @keyup.enter="applyFilter"
        /> </b-col
      > <b-col
        :md="showStoreFilter ? 2 : 5"
        class="mb-3"
        > <label class="einvoice-filter__label">Từ khóa</label> <b-input-group size="sm"
          > <b-input-group-prepend
            > <b-input-group-text> <i class="fas fa-search"></i> </b-input-group-text>
            </b-input-group-prepend
          > <b-form-input
            v-model="draftFilter.keyword"
            placeholder="Số HĐ, mã khách, tên khách..."
            @keyup.enter="applyFilter"
          /> </b-input-group
        > </b-col
      > </b-row
    > <b-row class="align-items-end"
      > <b-col
        cols="6"
        md="2"
        class="mb-3"
        > <label class="einvoice-filter__label">Ngày tạo HĐ từ</label>
        <date-picker
          v-model="draftFilter.dateFrom"
          placeholder="Từ ngày"
          class="form-control form-control-sm"
          :config="dpConfigs.date"
          @input.native="onDateNativeInput('dateFrom', $event)"
        /> </b-col
      > <b-col
        cols="6"
        md="2"
        class="mb-3"
        > <label class="einvoice-filter__label">Ngày tạo HĐ đến</label>
        <date-picker
          v-model="draftFilter.dateTo"
          placeholder="Đến ngày"
          class="form-control form-control-sm"
          :config="dpConfigs.date"
          @input.native="onDateNativeInput('dateTo', $event)"
        />
        <small
          v-if="isInvoiceDateRangeInvalid"
          class="d-block text-danger mt-1"
          > Ngày không hợp lệ </small
        > </b-col
      > <b-col
        cols="6"
        md="2"
        class="mb-3"
        > <label class="einvoice-filter__label">Phát hành từ</label>
        <date-picker
          v-model="draftFilter.issueDateFrom"
          placeholder="Từ ngày"
          class="form-control form-control-sm"
          :config="dpConfigs.date"
          @input.native="onDateNativeInput('issueDateFrom', $event)"
        /> </b-col
      > <b-col
        cols="6"
        md="2"
        class="mb-3"
        > <label class="einvoice-filter__label">Phát hành đến</label>
        <date-picker
          v-model="draftFilter.issueDateTo"
          placeholder="Đến ngày"
          class="form-control form-control-sm"
          :config="dpConfigs.date"
          @input.native="onDateNativeInput('issueDateTo', $event)"
        />
        <small
          v-if="isIssueDateRangeInvalid"
          class="d-block text-danger mt-1"
          > Ngày không hợp lệ </small
        > </b-col
      ><b-col
        md="2"
        class="mb-3"
        > <label class="einvoice-filter__label">Mã vận đơn</label> <b-form-input
          v-model="draftFilter.codeShip"
          size="sm"
          maxlength="100"
          placeholder="Nhập chính xác mã vận đơn..."
          @keyup.enter="applyFilter"
        /> </b-col
      > <b-col
        md="4"
        class="mb-3"
        >
        <div class="einvoice-filter__actions">
           <b-button
            size="sm"
            variant="primary"
            :disabled="isDateRangeInvalid"
            @click="applyFilter"
            > Áp dụng </b-button
          > <b-button
            size="sm"
            variant="outline-secondary"
            @click="resetFilter"
            > <i class="fas fa-undo mr-1"></i> Đặt lại </b-button
          >
        </div>
         </b-col
      > </b-row
    >
  </div>

</template>

<script>
  import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'
  import timeUtils from '@/utils/date'
  import { EINVOICE_STATUS, EINVOICE_STATUS_NAME } from '@/utils/einvoice.enum'
  import {
    buildBillTypeFilterOptions,
    normalizeBillTypeFilterSelection,
    normalizeBillTypeFilterSelectionSingle,
    selectBillTypeFilterSingle,
  } from '../utils/billTypeFilter.utils'
  import {
    buildAppliedFilterPayload,
    buildFilterDraft,
    isFilterDateRangeInvalid,
  } from '../utils/filterForm.utils'
  import einvoiceMixin from '../mixins/einvoice.mixin'

  export default {
    name: 'EInvoiceFilter',
    components: { BDropdownCustom },
    mixins: [einvoiceMixin],
    props: {
      stores: {
        type: Array,
        default: () => [],
      },
      filterValue: {
        type: Object,
        default: () => ({
          billTypes: undefined,
          status: null,
          keyword: '',
          storeIds: [],
          dateFrom: null,
          dateTo: null,
          page: 1,
        }),
      },
    },
    data() {
      return {
        dpConfigs: {
          date: {
            ...timeUtils.DP_CONFIG.date,
            widgetPositioning: { horizontal: 'auto', vertical: 'auto' },
          },
        },
        draftFilter: buildFilterDraft(),
        billTypeBlockedReason: null,
        selectedStores: [],
      }
    },
    computed: {
      billTypeOptions() {
        return buildBillTypeFilterOptions()
      },
      isInvoiceDateRangeInvalid() {
        return isFilterDateRangeInvalid(this.draftFilter.dateFrom, this.draftFilter.dateTo)
      },
      isIssueDateRangeInvalid() {
        return isFilterDateRangeInvalid(
          this.draftFilter.issueDateFrom,
          this.draftFilter.issueDateTo,
        )
      },
      isDateRangeInvalid() {
        return this.isInvoiceDateRangeInvalid || this.isIssueDateRangeInvalid
      },
      showStoreFilter() {
        return Array.isArray(this.stores) && this.stores.length > 1
      },
      statusOptions() {
        return [
          { value: EINVOICE_STATUS.DRAFT, text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.DRAFT] },
          // {
          //   value: EINVOICE_STATUS.READY_TO_ISSUE,
          //   text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.READY_TO_ISSUE],
          // },
          { value: EINVOICE_STATUS.ISSUING, text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.ISSUING] },
          {
            value: EINVOICE_STATUS.ISSUE_FAILED,
            text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.ISSUE_FAILED],
          },
          { value: EINVOICE_STATUS.ISSUED, text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.ISSUED] },
          {
            value: EINVOICE_STATUS.TAX_ACCEPTED,
            text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.TAX_ACCEPTED],
          },
          {
            value: EINVOICE_STATUS.TAX_REJECTED,
            text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.TAX_REJECTED],
          },
          { value: EINVOICE_STATUS.CANCELED, text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.CANCELED] },
          { value: EINVOICE_STATUS.ADJUSTED, text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.ADJUSTED] },
          { value: EINVOICE_STATUS.REPLACED, text: EINVOICE_STATUS_NAME[EINVOICE_STATUS.REPLACED] },
        ]
      },
    },
    watch: {
      filterValue: {
        deep: true,
        immediate: true,
        handler(value) {
          this.hydrateDraftFilter(value)
        },
      },
      stores: {
        deep: true,
        handler() {
          this.syncSelectedStores()
        },
      },
    },
    methods: {
      hydrateDraftFilter(filterValue) {
        this.draftFilter = {
          ...buildFilterDraft(filterValue),
          billTypes: normalizeBillTypeFilterSelectionSingle(filterValue?.billTypes),
        }
        this.billTypeBlockedReason = null
        this.syncSelectedStores()
      },
      syncSelectedStores() {
        const storeIds = this.draftFilter.storeIds || []
        if (!storeIds.length || !this.stores.length) {
          this.selectedStores = []
          return
        }
        this.selectedStores = this.stores.filter((store) => store && storeIds.includes(store.id))
      },
      onDateNativeInput(field, event) {
        const raw = event?.target?.value
        if (raw === '' || raw === null || raw === undefined) {
          if (this.draftFilter[field]) {
            this.draftFilter[field] = null
          }
        }
      },
      onStoreSelectionChange(stores) {
        const selected = Array.isArray(stores) ? stores.filter(Boolean) : []
        this.selectedStores = selected
        this.draftFilter.storeIds = selected.map((store) => store.id)
      },
      isBillTypeActive(billType) {
        return normalizeBillTypeFilterSelection(this.draftFilter.billTypes).includes(billType)
      },
      onToggleBillType(billType) {
        const result = selectBillTypeFilterSingle(billType)
        this.draftFilter.billTypes = result.billTypes
        this.billTypeBlockedReason = null
        this.applyFilter()
      },
      applyFilter() {
        if (this.isDateRangeInvalid) return

        this.$emit(
          'filter',
          buildAppliedFilterPayload({
            ...this.filterValue,
            ...this.draftFilter,
            page: 1,
          }),
        )
      },
      resetFilter() {
        this.draftFilter = buildFilterDraft()
        this.draftFilter.billTypes = normalizeBillTypeFilterSelectionSingle()
        this.billTypeBlockedReason = null
        this.selectedStores = []
        this.$emit('reset')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .einvoice-filter {
  &__label {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #5e6278;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-height: 31px;
    padding-top: 1.5rem;
  }

  .btn-group {
    display: flex;
  }

  .btn-group > .btn {
    flex: 1 1 0;
  }
}
</style>

<style lang="scss">
.einvoice-filter {
  .bootstrap-datetimepicker-widget {
    z-index: 1055 !important;
    position: absolute !important;
  }

  .input-group {
    flex-wrap: nowrap;
  }
}
</style>
